(function () {
  const FRACTIONS = [[0, ""], [0.25, "¼"], [0.5, "½"], [0.75, "¾"], [1, ""]];
  const LABELS = {
    fr: {
      locale: "fr-FR", unit_sep: " ", cs: "c. à s.", cc: "c. à c.", pinch: "1 pincée", to: "à", once: "en une seule fois", batches: "en {n} fournées",
      ready: "C'est prêt", copy: "Copier la liste de courses", copied: "Liste copiée", reset: "Tout décocher", short: "pers.",
      step_done: "Étape {n} faite", recipe: "La recette", prep: "Préparation", cook: "Cuisson", total: "Total", difficulty: "Difficulté",
      cuisine: "Cuisine", for: "Pour", people: "personnes", less: "Une personne de moins", more: "Une personne de plus",
      ingredients: "Ingrédients", tools: "Matériel", steps: "Préparation", tips: "Astuces wok", variants: "Variantes",
      storage: "Conservation", protein: "g protéines", carbs: "g glucides", fat: "g lipides", faq: "Questions fréquentes", sec: "s",
      jump: "Aller à la recette", print: "Imprimer", cook_mode: "Mode cuisine", cook_exit: "Quitter le mode cuisine", in_all: "en tout",
      spice: "Piquant", spice_levels: ["Pas piquant", "Un peu piquant", "Piquant", "Très piquant"],
    },
    en: {
      locale: "en-GB", unit_sep: "", cs: "tbsp", cc: "tsp", pinch: "a pinch of", to: "to", once: "in one go", batches: "in {n} batches",
      ready: "Ready", copy: "Copy the shopping list", copied: "List copied", reset: "Untick all", short: "servings",
      step_done: "Step {n} done", recipe: "The recipe", prep: "Prep", cook: "Cook", total: "Total", difficulty: "Difficulty",
      cuisine: "Cuisine", for: "For", people: "people", less: "One person fewer", more: "One person more",
      ingredients: "Ingredients", tools: "Equipment", steps: "Method", tips: "Wok tips", variants: "Variations",
      storage: "Storage", protein: "g protein", carbs: "g carbs", fat: "g fat", faq: "Frequently asked questions", sec: "sec",
      jump: "Jump to the recipe", print: "Print", cook_mode: "Cooking mode", cook_exit: "Exit cooking mode", in_all: "in total",
      spice: "Heat", spice_levels: ["Not spicy", "Mild", "Medium", "Hot"],
    },
    nl: {
      locale: "nl-NL", unit_sep: " ", cs: "el", cc: "tl", pinch: "een snufje", to: "à", once: "in één keer", batches: "in {n} delen",
      ready: "Klaar", copy: "Boodschappenlijst kopiëren", copied: "Lijst gekopieerd", reset: "Alles uitvinken", short: "pers.",
      step_done: "Stap {n} klaar", recipe: "Het recept", prep: "Voorbereiding", cook: "Kooktijd", total: "Totaal", difficulty: "Moeilijkheid",
      cuisine: "Keuken", for: "Voor", people: "personen", less: "Eén persoon minder", more: "Eén persoon meer",
      ingredients: "Ingrediënten", tools: "Benodigdheden", steps: "Bereiding", tips: "Woktips", variants: "Varianten",
      storage: "Bewaren", protein: "g eiwit", carbs: "g koolhydraten", fat: "g vet", faq: "Veelgestelde vragen", sec: "sec",
      jump: "Naar het recept", print: "Afdrukken", cook_mode: "Kookmodus", cook_exit: "Kookmodus verlaten", in_all: "in totaal",
      spice: "Pittig", spice_levels: ["Niet pittig", "Licht pittig", "Pittig", "Heel pittig"],
    },
    de: {
      locale: "de-DE", unit_sep: " ", cs: "EL", cc: "TL", pinch: "1 Prise", to: "bis", once: "auf einmal", batches: "in {n} Durchgängen",
      ready: "Fertig", copy: "Einkaufsliste kopieren", copied: "Liste kopiert", reset: "Alle Haken entfernen", short: "Pers.",
      step_done: "Schritt {n} erledigt", recipe: "Das Rezept", prep: "Vorbereitung", cook: "Garzeit", total: "Gesamt", difficulty: "Schwierigkeit",
      cuisine: "Küche", for: "Für", people: "Personen", less: "Eine Person weniger", more: "Eine Person mehr",
      ingredients: "Zutaten", tools: "Zubehör", steps: "Zubereitung", tips: "Wok-Tipps", variants: "Varianten",
      storage: "Aufbewahrung", protein: "g Eiweiß", carbs: "g Kohlenhydrate", fat: "g Fett", faq: "Häufige Fragen", sec: "Sek.",
      jump: "Zum Rezept", print: "Drucken", cook_mode: "Kochmodus", cook_exit: "Kochmodus beenden", in_all: "insgesamt",
      spice: "Schärfe", spice_levels: ["Nicht scharf", "Leicht scharf", "Scharf", "Sehr scharf"],
    },
    da: {
      locale: "da-DK", unit_sep: " ", cs: "spsk.", cc: "tsk.", pinch: "1 knivspids", to: "til", once: "på én gang", batches: "i {n} omgange",
      ready: "Klar", copy: "Kopiér indkøbslisten", copied: "Listen er kopieret", reset: "Fjern alle flueben", short: "pers.",
      step_done: "Trin {n} udført", recipe: "Opskriften", prep: "Forberedelse", cook: "Tilberedning", total: "I alt", difficulty: "Sværhedsgrad",
      cuisine: "Køkken", for: "Til", people: "personer", less: "En person færre", more: "En person mere",
      ingredients: "Ingredienser", tools: "Udstyr", steps: "Fremgangsmåde", tips: "Woktips", variants: "Varianter",
      storage: "Opbevaring", protein: "g protein", carbs: "g kulhydrat", fat: "g fedt", faq: "Ofte stillede spørgsmål", sec: "sek.",
      jump: "Gå til opskriften", print: "Udskriv", cook_mode: "Madlavningstilstand", cook_exit: "Afslut madlavningstilstand", in_all: "i alt",
      spice: "Styrke", spice_levels: ["Ikke stærk", "Lidt stærk", "Stærk", "Meget stærk"],
    },
  };

  const CHILI = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#D7261E" d="M11.8 8.9C13.6 8.3 15.9 8.6 17.2 9.8C18 14 12 20.2 5.4 21.7C4.7 21.9 4.4 21 5 20.6C9.3 18 11.6 13.6 11.8 8.9Z"/><path fill="#2F8F4E" d="M11.2 9.2C11.5 7.3 13.8 6.6 15.6 7.1C17 7.5 17.9 8.6 17.7 10C16.1 8.8 13.4 8.5 11.2 9.2Z"/><path fill="none" stroke="#2F8F4E" stroke-width="1.8" stroke-linecap="round" d="M14.8 7C14.6 5.2 15.4 3.6 17.3 2.7"/></svg>';

  function spice(level, L) {
    const inner = level === 0 ? '<i class="rc-dot" aria-hidden="true"></i>'
      : '<i class="rc-chilis">' + [1, 2, 3].map(i => '<i class="rc-chili' + (i <= level ? " on" : "") + '">' + CHILI + "</i>").join("") + "</i>";
    return '<span class="rc-spice" data-level="' + level + '">' + inner + L.spice_levels[level] + "</span>";
  }

  function esc(s) {
    return String(s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
  }

  function fraction(x, step) {
    const whole = Math.floor(x + 1e-9);
    let rest = x - whole, best = FRACTIONS[0], gap = 1;
    for (const f of FRACTIONS) {
      if (step === 0.5 && f[1] && f[0] !== 0.5) continue;
      if (Math.abs(rest - f[0]) < gap) { gap = Math.abs(rest - f[0]); best = f; }
    }
    const w = best[0] === 1 ? whole + 1 : whole;
    if (!w && !best[1]) return null;
    return (w ? String(w) : "") + (best[1] ? (w ? " " : "") + best[1] : "");
  }

  function metric(q, unit, L) {
    const step = q < 20 ? 1 : q < 250 ? 5 : 10;
    const v = Math.max(step, Math.round(q / step) * step);
    if (unit === "ml" && v >= 1000) return (v / 1000).toLocaleString(L.locale, { maximumFractionDigits: 1 }) + L.unit_sep + "l";
    if (unit === "g" && v >= 1000) return (v / 1000).toLocaleString(L.locale, { maximumFractionDigits: 2 }) + L.unit_sep + "kg";
    return v + L.unit_sep + unit;
  }

  function spoons(q, unit, liquid, L) {
    const tsp = unit === "cs" ? q * 3 : q;
    if (tsp < 0.2) return L.pinch;
    if (tsp < 3) return (fraction(tsp, 0.25) || "¼") + " " + L.cc;
    const tbsp = tsp / 3;
    if (liquid && tbsp > 8) return metric(tbsp * 15, "ml", L);
    return fraction(tbsp, 0.5) + " " + L.cs;
  }

  function count(q, item, mode) {
    if (item.demi) return q < 0.375 ? "¼" : fraction(Math.round(q * 2) / 2, 0.5);
    const v = mode === "floor" ? Math.floor(q + 1e-9) : mode === "ceil" ? Math.ceil(q - 1e-9) : Math.round(q);
    return String(Math.max(1, v));
  }

  function hasBatches(data) {
    return !!(data.cuisson && data.cuisson.fournee_g);
  }

  function batches(data, f) {
    if (!hasBatches(data)) return 1;
    const c = data.cuisson, base = byId(data, c.ingredient);
    return Math.max(1, Math.ceil((base.q * f) / c.fournee_g - 1e-9));
  }

  function amount(item, f, n, L) {
    if (item.q == null) return "";
    const q = item.par_fournee && n ? item.par_fournee * n : item.q * f;
    if (item.u === "g" || item.u === "ml") return metric(q, item.u, L);
    if (item.u === "cs" || item.u === "cc") return spoons(q, item.u, item.liquide, L);
    if (item.q2 != null) {
      const lo = count(q, item, "floor"), hi = count(item.q2 * f, item, "ceil");
      return lo === hi ? lo : lo + " " + L.to + " " + hi;
    }
    return count(q, item, "round");
  }

  function plural(item, txt, L) {
    const last = parseFloat(String(txt).split(" " + L.to + " ").pop().replace(",", "."));
    return item.np && last >= 2 ? item.np : item.n;
  }

  function scaledInline(text, f, L) {
    return text.replace(/\[\[(\d+(?:[.,]\d+)?) (g|ml)\]\]/g, (_, v, u) => metric(parseFloat(v.replace(",", ".")) * f, u, L));
  }

  function byId(data, id) {
    for (const g of data.groupes) for (const it of g.items) if (it.id === id) return it;
    return null;
  }

  function batchText(n, L) {
    return n === 1 ? L.once : L.batches.replace("{n}", n);
  }

  function stepText(data, step, f, n, L) {
    return (n === 1 && step.texte_une_fournee ? step.texte_une_fournee : step.texte)
      .replace(/\{\{fournees\}\}/g, '<b class="rc-dyn">' + batchText(n, L) + "</b>")
      .replace(/\{\{(\w+)\}\}/g, (_, id) => {
        const it = byId(data, id);
        return it ? '<b class="rc-dyn">' + amount(it, f, hasBatches(data) ? n : 0, L) + "</b>" : "";
      });
  }

  function mmss(s) {
    return Math.floor(s / 60) + ":" + String(s % 60).padStart(2, "0");
  }

  function timerView(secs, tm, L) {
    if (tm && tm.end) return { cls: "rc-timer is-end", text: L.ready };
    if (tm) return { cls: "rc-timer is-run", text: mmss(Math.max(0, tm.left)) };
    return { cls: "rc-timer", text: secs >= 60 ? Math.round(secs / 60) + " min" : secs + " " + L.sec };
  }

  function cookTime(data, n) {
    return data.cuisson.base_min + (hasBatches(data) ? data.cuisson.par_fournee_min * n : 0);
  }

  function render(data, servings, lang, state) {
    const L = LABELS[lang] || LABELS.fr, st = state || {};
    const checked = st.checked || new Set(), done = st.done || new Set(), timers = st.timers || new Map();
    const f = servings / data.portions, n = batches(data, f), nb = hasBatches(data) ? n : 0, cook = cookTime(data, n);
    const tips = data.wok || [];
    const tip = tips.find(w => servings <= w.max_portions) || tips[tips.length - 1];
    const images = data.images || {};

    const groupsHtml = data.groupes.map(g => (
      '<div class="rc-group"><h4>' + g.titre + "</h4><ul>" + g.items.map(it => {
        const a = amount(it, f, nb, L), on = checked.has(it.id);
        const note = it.note ? ' <span class="rc-note">' + scaledInline(it.note, f, L) + "</span>" : "";
        return '<li><label class="rc-ing' + (on ? " is-on" : "") + '"><input type="checkbox" data-ing="' + it.id + '"' + (on ? " checked" : "") +
          "><span>" + (a ? '<b class="rc-qty">' + a + "</b> " : "") + plural(it, a, L) + note + "</span></label></li>";
      }).join("") + "</ul></div>"
    )).join("");

    const stepsHtml = data.etapes.map((s, i) => {
      const img = s.image && images[s.image];
      const tv = s.minuteur_s && timerView(s.minuteur_s, timers.get(i), L);
      const timer = tv ? '<button type="button" class="' + tv.cls + '" data-timer="' + s.minuteur_s + '" data-timer-step="' + i +
        '"><span class="rc-ico" aria-hidden="true">◷</span> <span>' + tv.text + "</span></button>" : "";
      return '<li id="etape-' + (i + 1) + '" class="rc-step' + (done.has(i) ? " is-done" : "") + '">' +
        '<button type="button" class="rc-num" data-step="' + i + '" aria-label="' + esc(L.step_done.replace("{n}", i + 1)) + '">' + (i + 1) + "</button>" +
        '<div class="rc-body"><h4>' + s.titre + "</h4><p>" + stepText(data, s, f, n, L) + "</p>" + timer +
        (img ? '<img loading="lazy" src="' + esc(img) + '" alt="' + esc(s.titre) + '">' : "") + "</div></li>";
    }).join("");

    return { groupsHtml, stepsHtml, cook, total: data.preparation_min + cook, woktip: tip ? tip.texte : "" };
  }

  function lines(data, servings, lang) {
    const L = LABELS[lang] || LABELS.fr, f = servings / data.portions, n = batches(data, f), nb = hasBatches(data) ? n : 0;
    const ingredients = [];
    data.groupes.forEach(g => g.items.forEach(it => {
      const a = amount(it, f, nb, L);
      ingredients.push({ id: it.id, text: ((a ? a + " " : "") + plural(it, a, L)).trim() });
    }));
    const steps = data.etapes.map(s => stepText(data, s, f, n, L).replace(/<[^>]+>/g, ""));
    return { ingredients, steps };
  }

  if (typeof module !== "undefined") {
    module.exports = { render, lines, LABELS, esc, spice };
    return;
  }

  function beep() {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      [0, 0.35, 0.7].forEach(t => {
        const o = ctx.createOscillator(), g = ctx.createGain();
        o.frequency.value = 880; o.connect(g); g.connect(ctx.destination);
        g.gain.setValueAtTime(0.25, ctx.currentTime + t);
        g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + 0.3);
        o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + 0.3);
      });
    } catch (e) {}
    try { navigator.vibrate && navigator.vibrate([200, 100, 200]); } catch (e) {}
  }

  function store(key, value) {
    try {
      if (value === undefined) return JSON.parse(localStorage.getItem(key) || "null");
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) { return null; }
  }

  function mount(root) {
    const data = JSON.parse(root.querySelector("script[type='application/json']").textContent);
    const lang = root.dataset.lang || "fr", L = LABELS[lang] || LABELS.fr;
    const key = "rc:" + (root.dataset.handle || data.nom);
    const saved = store(key) || {};
    const clamp = v => Math.min(data.portions_max, Math.max(data.portions_min, v));
    const state = { checked: new Set(saved.checked || []), done: new Set(saved.done || []), timers: new Map() };
    let servings = clamp(saved.servings || data.portions);
    const $ = sel => root.querySelector(sel);

    function save() {
      store(key, { servings, checked: [...state.checked], done: [...state.done] });
    }

    function draw() {
      const r = render(data, servings, lang, state);
      $("[data-rc=servings]").textContent = servings;
      $("[data-rc=minus]").disabled = servings <= data.portions_min;
      $("[data-rc=plus]").disabled = servings >= data.portions_max;
      root.querySelectorAll("[data-rc-preset]").forEach(b => b.setAttribute("aria-pressed", String(+b.dataset.rcPreset === servings)));
      $("[data-rc=cooktime]").textContent = r.cook + " min";
      $("[data-rc=total]").textContent = r.total + " min";
      const tip = $("[data-rc=woktip]");
      if (tip) tip.textContent = r.woktip;
      $("[data-rc=groups]").innerHTML = r.groupsHtml;
      $("[data-rc=steps]").innerHTML = r.stepsHtml;
      save();
    }

    function paintTimer(i) {
      const btn = root.querySelector('[data-timer-step="' + i + '"]');
      if (!btn) return;
      const tv = timerView(+btn.dataset.timer, state.timers.get(i), L);
      btn.className = tv.cls;
      btn.lastElementChild.textContent = tv.text;
    }

    function toggleTimer(btn) {
      const i = +btn.dataset.timerStep, running = state.timers.get(i);
      if (running && running.iv) {
        clearInterval(running.iv);
        state.timers.delete(i);
        return paintTimer(i);
      }
      const tm = { left: +btn.dataset.timer, iv: null, end: false };
      state.timers.set(i, tm);
      tm.iv = setInterval(() => {
        tm.left -= 1;
        if (tm.left <= 0) { clearInterval(tm.iv); tm.iv = null; tm.end = true; beep(); }
        paintTimer(i);
      }, 1000);
      paintTimer(i);
    }

    root.addEventListener("click", e => {
      const t = e.target.closest("button");
      if (!t || !root.contains(t)) return;
      if (t.dataset.rc === "minus") { servings = clamp(servings - 1); draw(); }
      else if (t.dataset.rc === "plus") { servings = clamp(servings + 1); draw(); }
      else if (t.dataset.rcPreset) { servings = clamp(+t.dataset.rcPreset); draw(); }
      else if (t.dataset.step) {
        const i = +t.dataset.step;
        state.done.has(i) ? state.done.delete(i) : state.done.add(i);
        t.closest(".rc-step").classList.toggle("is-done");
        save();
      } else if (t.dataset.timerStep) toggleTimer(t);
      else if (t.dataset.rc === "copy") copyList(t);
      else if (t.dataset.rc === "reset") { state.checked.clear(); state.done.clear(); draw(); }
      else if (t.dataset.rc === "print") window.print();
      else if (t.dataset.rc === "cook") toggleCookMode(t);
    });

    root.addEventListener("change", e => {
      const id = e.target.dataset.ing;
      if (!id) return;
      e.target.checked ? state.checked.add(id) : state.checked.delete(id);
      e.target.closest(".rc-ing").classList.toggle("is-on", e.target.checked);
      save();
    });

    function copyList(btn) {
      const items = lines(data, servings, lang).ingredients.filter(it => !state.checked.has(it.id));
      const text = [data.nom + " (" + servings + " " + L.short + ")"].concat(items.map(it => "- " + it.text)).join("\n");
      const ok = () => { btn.textContent = L.copied; setTimeout(() => (btn.textContent = L.copy), 2000); };
      (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject()).then(ok, () => {
        const ta = document.createElement("textarea"); ta.value = text; document.body.appendChild(ta); ta.select();
        try { document.execCommand("copy"); ok(); } catch (e) {} ta.remove();
      });
    }

    let lock = null;
    async function toggleCookMode(btn) {
      const on = !document.documentElement.classList.contains("rc-cooking");
      document.documentElement.classList.toggle("rc-cooking", on);
      btn.setAttribute("aria-pressed", String(on));
      try {
        if (on && navigator.wakeLock) lock = await navigator.wakeLock.request("screen");
        else if (lock) { await lock.release(); lock = null; }
      } catch (e) {}
      document.querySelectorAll(".rc-cookbar").forEach(b => (b.hidden = !on));
      if (on) root.scrollIntoView({ behavior: "smooth" });
    }

    draw();
  }

  function trackHeader() {
    const header = [...document.querySelectorAll("header, .shopify-section-group-header-group")]
      .find(h => /sticky|fixed/.test(getComputedStyle(h).position));
    if (!header) return;
    const set = () => document.documentElement.style.setProperty("--rc-header", Math.round(header.getBoundingClientRect().height) + "px");
    set();
    if (window.ResizeObserver) new ResizeObserver(set).observe(header);
  }

  document.querySelectorAll("[data-recipe-card]").forEach(mount);
  if (document.querySelector("[data-recipe-card]")) trackHeader();
  document.addEventListener("click", e => {
    const go = e.target.closest("[data-rc-go]");
    const target = go && document.querySelector("[data-recipe-card] [data-rc=" + go.dataset.rcGo + "]");
    if (target) target.click();
  });
})();
